import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const PLATFORM_META = {
  linkedin: { label: "LinkedIn", color: "#0A66C2" },
  facebook: { label: "Facebook", color: "#1877F2" },
  instagram: { label: "Instagram", color: "#E4405F" },
  threads: { label: "Threads", color: "#A3A3A3" },
};

/* One colour per status, everywhere: pills, calendar dots, filters (PRD 23).
   Pink is reserved for "needs you". */
export const STATUS_META = {
  draft: { label: "Drafting", cls: "bg-[#1C1F2B] text-[#E5E7EB] border-[#30344A]", dot: "#E5E7EB" },
  generating: { label: "Drafting", cls: "bg-[#1C1F2B] text-[#E5E7EB] border-[#30344A]", dot: "#E5E7EB" },
  pending_approval: { label: "Needs you", cls: "bg-[#3B1029] text-[#F9A8D4] border-[#6B1D47]", dot: "#F472B6" },
  approved: { label: "Approved", cls: "bg-[#1E2150] text-[#C7D2FE] border-[#33378A]", dot: "#A5B4FC" },
  scheduled: { label: "Scheduled", cls: "bg-[#191C45] text-[#A5B4FC] border-[#2C3170]", dot: "#818CF8" },
  rejected: { label: "Rejected", cls: "bg-[#1A1D29] text-[#9CA3B4] border-[#2A2E3E]", dot: "#9CA3B4" },
  posted: { label: "Published", cls: "bg-[#0F2A1B] text-[#86EFAC] border-[#1A4D30]", dot: "#4ADE80" },
  failed: { label: "Failed", cls: "bg-[#3A1414] text-[#FCA5A5] border-[#6B2121]", dot: "#F87171" },
};

export const POST_FORMATS = {
  static: { label: "Static Image", desc: "One AI image + caption" },
  viral: { label: "Viral Post", desc: "Hook-driven high-reach copy" },
  carousel: { label: "Carousel", desc: "Multi-slide swipe post" },
};

/* A post's image may arrive either way: freshly generated in the browser it is
   base64 in memory; loaded from the server it is a short-lived signed URL,
   because the bytes live in their own collection rather than inside the post. */
export const imageSrc = (obj) =>
  obj?.image_base64 ? `data:image/png;base64,${obj.image_base64}` : obj?.image_url || null;

export default api;
